<div class="filter-container" cdkOverlayOrigin #trigger="cdkOverlayOrigin">
  <edt-filter-header
    [countActiveFilters]="selection.selected.length"
    [filterName]="title"
    (openFilter)="toogleOpen($event)"
  ></edt-filter-header>

  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="isOpen"
    cdkConnectedOverlayWidth="300"
    (overlayOutsideClick)="close()"
  >
    <div class="filter-menu">
      @if (listItems) {
      <div class="row align-items-start">
        @if (showSelectAllOption) {
        <div class="col-12 mb-1">
          <mat-checkbox
            [checked]="allSelected"
            [indeterminate]="!!selection.selected.length && !allSelected"
            (change)="toggleMasterSelection()"
          >
            Seleccionar todos</mat-checkbox
          >
        </div>
        }

        <div class="col-12 my-1">
          <cdk-virtual-scroll-viewport
            class="content-scrollable"
            [itemSize]="itemSize"
          >
            <mat-list>
              <mat-list-item
                *cdkVirtualFor="let item of listItems"
                role="listitem"
              >
                <mat-checkbox
                  [checked]="selection.isSelected(item)"
                  (change)="toogleItem(item)"
                >
                  {{ item.title }}
                </mat-checkbox>
              </mat-list-item>
            </mat-list>
          </cdk-virtual-scroll-viewport>
        </div>

        @if (!!selection.selected.length) {
        <div class="col-12 my-1 text-end">
          <button class="me-2" mat-button (click)="clear()">
            Borrar selección
          </button>
        </div>
        }
      </div>
      } @else {

      <common-ui-spinner></common-ui-spinner>

      }
    </div>
  </ng-template>
</div>
